<template>
  <div class="user-edit">
    <el-form class="zwx-form" style="padding: 0 !important;" key="mainForm" ref="mainForm" :model="mainForm" :rules="rules" label-position="right">
      <!-- 基础信息部分 -->
      <headline title="基本信息" class="headline" />
      <el-divider class="base-divider" />
      <div style="max-width: 544px; padding: 10px 0 5px 20px !important;">
        <el-form-item label-width="82px" label="地区：" required>
          <zwx-select-area ref="areaSelect" @change="areaSelectChange()" @loadOver="areaSelectLoadOver()" :zoneCode12From="zoneCode12From" zoneTypeMax="0" zoneTypeMin="4" :showFullName="false" :disabled="false" :clearable="false" />
        </el-form-item>
        <el-form-item label-width="82px" label="机构名称：" prop="fkByUnitId.rid">
          <el-select class="zwx-select" popper-class="zwx-select-popper" v-model="mainForm.fkByUnitId.rid" @change="unitChange" placeholder="请选择" :filterable="true" :clearable="true">
            <el-option v-for="item in unitList" :key="item.rid" :label="item.unitName" :value="item.rid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="82px" label="用户账号：" prop="userNo">
          <el-input class="zwx-input" v-model="mainForm.userNo" @input="$validate.capitalizationNumbers($data['mainForm'], 'userNo')" maxlength="30" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="82px" label="用户姓名：" prop="userName">
          <el-input class="zwx-input" v-model="mainForm.userName" maxlength="100" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="82px" label="组织架构：">
          <custom-multiple ref="userOrganIdRef" v-model="mainForm.organIdList" speed="rid" value="organName" :clearable="true" :collapseTags="true" :disabled="false" />
        </el-form-item>
        <el-form-item label-width="82px" label="曾用名：">
          <el-input class="zwx-input" v-model="mainForm.usedName" maxlength="100" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="82px" label="性别：">
          <code-radio :codeType="userSexCodeTypeCode" v-model="mainForm.userSex" />
        </el-form-item>
        <el-form-item label-width="82px" label="手机号码：" prop="mobileTel">
          <el-input class="zwx-input" v-model="mainForm.mobileTel" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="82px" label="身份证号：" prop="idc">
          <el-input class="zwx-input" v-model="mainForm.idc" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="82px" label="民族：">
          <code-select :codeType="userNationCodeTypeCode" v-model="mainForm.userNation" :clearable="true" />
        </el-form-item>
        <el-form-item label-width="82px" label="学历：">
          <code-select :codeType="educationCodeTypeCode" v-model="mainForm.education" :clearable="true" />
        </el-form-item>
        <el-form-item label-width="82px" label="学位：">
          <code-select :codeType="degreeCodeTypeCode" v-model="mainForm.degree" :clearable="true" />
        </el-form-item>
        <el-form-item label-width="82px" label="婚姻状况：">
          <code-select :codeType="maritalStatusCodeTypeCode" v-model="mainForm.maritalStatus" :clearable="true" />
        </el-form-item>
        <el-form-item label-width="82px" label="政治面貌：">
          <code-select :codeType="politicalLandscapeCodeTypeCode" v-model="mainForm.politicalLandscape" :clearable="true" />
        </el-form-item>
        <el-form-item label-width="82px" label="宗教信仰：">
          <code-select :codeType="religionCodeTypeCode" v-model="mainForm.religion" :clearable="true" />
        </el-form-item>
        <el-form-item label-width="82px" label="职位：">
          <el-input class="zwx-input" v-model="mainForm.position" maxlength="30" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="82px" label="职称：">
          <el-input class="zwx-input" v-model="mainForm.jobTitle" maxlength="30" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="82px" label="状态：" required>
          <el-radio-group class="zwx-radio-group" v-model="mainForm.ifEnable">
            <el-radio class="zwx-radio" :label="true">启用</el-radio>
            <el-radio class="zwx-radio" :label="false">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
    <el-divider class="base-divider" />
    <!-- 提交部分 -->
    <div style="padding: 12px 20px;">
      <el-button class="zwx-button zwx-button-28" type="primary" @click="$system.valid($refs['mainForm'], '提示', '确定要提交吗？', '确定', '取消', commit)">提交</el-button>
      <el-button class="zwx-button zwx-button-28" @click="back()">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserEdit',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      zoneCode12From: undefined,
      userSexCodeTypeCode: this.$route.params.userSexCodeTypeCode,
      userNationCodeTypeCode: this.$route.params.userNationCodeTypeCode,
      educationCodeTypeCode: this.$route.params.educationCodeTypeCode,
      degreeCodeTypeCode: this.$route.params.degreeCodeTypeCode,
      maritalStatusCodeTypeCode: this.$route.params.maritalStatusCodeTypeCode,
      politicalLandscapeCodeTypeCode: this.$route.params.politicalLandscapeCodeTypeCode,
      religionCodeTypeCode: this.$route.params.religionCodeTypeCode,
      unitList: [],
      mainForm: {
        fkByUnitId: { rid: '' },
        userNo: '',
        userName: '',
        organIdList: [],
        usedName: '',
        userSex: '',
        userNation: '',
        idc: '',
        mobileTel: '',
        education: '',
        degree: '',
        position: '',
        jobTitle: '',
        maritalStatus: '',
        politicalLandscape: '',
        religion: '',
        ifEnable: true,
      },
      rules: {
        fkByUnitId: { rid: [{ required: true, message: '请选择机构名称', trigger: ['change', 'blur'] }] },
        userNo: [{ required: true, message: '请输入用户账号', trigger: ['change', 'blur'] }],
        userName: [{ required: true, message: '请输入用户姓名', trigger: ['change', 'blur'] }],
        idc: [{ required: false, validator: this.$validate.idcCode, trigger: ['change', 'blur'] }],
        mobileTel: [{ required: false, validator: this.$validate.mobilePhone, trigger: ['change', 'blur'] }],
      },
    }
  },
  created() {
    this.zoneCode12From = this.users.ifSuperAdmin ? '000000000000' : this.users.fkByUnitId.fkByZoneId.zoneCode12
  },
  mounted() {
    this.detail()
  },
  computed: {
    breadcrumbs() {
      return this.$store.state.breadcrumbs
    },
  },
  methods: {
    detail() {
      this.$emit('loading', true)
      if (this.rid === undefined) {
        this.$refs.areaSelect.initSearch()
        return
      }
      let data = {
        rid: this.rid,
      }
      this.$system.get(this.api + '/systematic/getUserInfo-1', data, true, true, this.detailSuccess, this.detailError)
    },
    detailSuccess(data) {
      if (data.type === '00') {
        this.$refs.areaSelect.initSearch(data.userInfo.fkByUnitId.fkByZoneId.zoneCode12)
        this.mainForm.fkByUnitId.rid = data.userInfo.fkByUnitId.rid
        this.mainForm.userNo = data.userInfo.userNo
        this.mainForm.userName = data.userInfo.userName
        this.setDetailOrganIdList(data.userInfo.organList)
        this.mainForm.usedName = data.userInfo.usedName
        this.mainForm.userSex = data.userInfo.userSex
        this.mainForm.userNation = data.userInfo.userNation
        this.mainForm.idc = this.$zwxSm.sm4JsDecrypt(data.userInfo.idc)
        this.mainForm.mobileTel = this.$zwxSm.sm4JsDecrypt(data.userInfo.mobileTel)
        this.mainForm.education = data.userInfo.education
        this.mainForm.degree = data.userInfo.degree
        this.mainForm.position = data.userInfo.position
        this.mainForm.jobTitle = data.userInfo.jobTitle
        this.mainForm.maritalStatus = data.userInfo.maritalStatus
        this.mainForm.politicalLandscape = data.userInfo.politicalLandscape
        this.mainForm.religion = data.userInfo.religion
        this.mainForm.ifEnable = data.userInfo.ifEnable
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
        this.back()
      }
    },
    detailError() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
      this.back()
    },
    areaSelectLoadOver() {
      this.$emit('loading', false)
    },
    areaSelectChange() {
      this.unitList.splice(0, this.unitList.length)
      this.$refs.userOrganIdRef.setDataList([])
      let data = {
        areaZoneCode12: this.$refs.areaSelect.getChooseArea().zoneCode12,
      }
      this.$system.get(this.api + '/systematic/getUnitListByAreaChild-1', data, true, true, this.unitListByAreaChildSuccess)
    },
    unitListByAreaChildSuccess(data) {
      let hasUnit = false
      if (data.type === '00') {
        this.unitList = data.unitList
        for (let i = 0, length = this.unitList.length; i < length; i++) {
          if (this.unitList[i].rid === this.mainForm.fkByUnitId.rid) {
            hasUnit = true
            break
          }
        }
      }
      if (hasUnit) {
        this.zoneChangeUnitNoChange()
      } else {
        this.mainForm.fkByUnitId.rid = ''
        this.mainForm.organIdList.splice(0, this.mainForm.organIdList.length)
        this.$refs.userOrganIdRef.setDataList([])
      }
    },
    unitChange() {
      this.mainForm.organIdList.splice(0, this.mainForm.organIdList.length)
      this.zoneChangeUnitNoChange()
    },
    zoneChangeUnitNoChange() {
      this.$refs.userOrganIdRef.setDataList([])
      let data = {
        unitId: this.mainForm.fkByUnitId.rid,
      }
      this.$system.get(this.api + '/systematic/getOrganByUnitIdList-1', data, true, true, this.zoneChangeUnitNoChangeSuccess)
    },
    zoneChangeUnitNoChangeSuccess(data) {
      if (data.type === '00') {
        this.$refs.userOrganIdRef.setDataList(data.organList)
      }
    },
    commit() {
      this.$emit('loading', true)
      let data = {
        rid: this.rid,
        fkByUnitId: { rid: this.mainForm.fkByUnitId.rid },
        userNo: this.mainForm.userNo,
        userName: this.mainForm.userName,
        organIdList: this.getCommitOrganIdList(),
        usedName: this.mainForm.usedName,
        userSex: this.mainForm.userSex,
        userNation: this.mainForm.userNation,
        idc: this.mainForm.idc,
        mobileTel: this.mainForm.mobileTel,
        education: this.mainForm.education,
        degree: this.mainForm.degree,
        position: this.mainForm.position,
        jobTitle: this.mainForm.jobTitle,
        maritalStatus: this.mainForm.maritalStatus,
        politicalLandscape: this.mainForm.politicalLandscape,
        religion: this.mainForm.religion,
        ifEnable: this.mainForm.ifEnable,
      }
      this.$system.postJson(this.api + '/systematic/addOrModifyUserInfo-1', data, true, true, this.commitSuccess, this.commitError)
    },
    commitSuccess(data) {
      if (data.type === '00') {
        this.$system.notify('成功', data.mess, 'success')
        this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name, params: { fresh: true } })
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    commitError() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
    back() {
      this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name })
    },
    setDetailOrganIdList(organList) {
      this.mainForm.organIdList.splice(0, this.mainForm.organIdList.length)
      if (!organList || organList.length === 0) return
      for (let i = 0, length = organList.length; i < length; i++) {
        this.mainForm.organIdList.push(organList[i].rid)
      }
    },
    getCommitOrganIdList() {
      const dataList = this.$refs.userOrganIdRef.getDataList()
      if (dataList.length === 0) return []
      const dataRidList = []
      for (let i = 0, length = dataList.length; i < length; i++) {
        dataRidList.push(dataList[i].rid)
      }
      return dataRidList
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
